'use client';
import { ReactNode, useEffect } from 'react';
import { useTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';
import { useAuth } from '@web-libs/features/auth/main/application/use-auth.concern';
import { LoadingIndicator } from '@web-libs/ui/ui-components/loading/loading-indicator';

const AuthGuard = ({
  children,
  isAuthenticated,
}: {
  children: ReactNode;
  isAuthenticated?: boolean;
}) => {
  const auth = useAuth();
  const router = useTageaRouter();

  useEffect(() => {
    if (!isAuthenticated) {
      auth.requestLogin().catch((e) => {
        router.push('/');
      });
    }
  });

  useEffect(() => {
    if (auth.isAuthenticated === null) {
      return;
    }
    if (!auth.isAuthenticated) {
      setTimeout(() => {
        router.push('/');
      }, 2000);
    }
  }, [auth.isAuthenticated]);

  if (isAuthenticated && auth.authToken) {
    return <>{children}</>;
  } else {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadingIndicator></LoadingIndicator>
      </div>
    );
  }
};

export default AuthGuard;
